import React from 'react'
import useStyles from './Styles'
import { Button as ButtonBase } from '@material-ui/core'
import { IProps } from './Interface'

const Button: React.FC<IProps> = ({ bgColor, fontColor, textTransform, flat, ...props }) => {
  const classes = useStyles({ bgColor, fontColor, textTransform, flat })

  return (
    <ButtonBase
      {...props}
      classes={{
        root: classes.root
      }}
    />
  )
}

Button.defaultProps = {
  bgColor: 'lightBlue',
  fontColor: 'white',
  textTransform: 'uppercase',
  flat: false
}

export default Button
